if (!window.initBlogApp) {
    window.initBlogApp = function () {
        const tags = document.querySelectorAll(".tags-list .link")

        for (let index = 0; index < tags.length; index++) {
            tags[index].addEventListener("click", function (event) {
                event.preventDefault()

                const path = window.location.protocol + '//' + window.location.hostname + tags[index].getAttribute("href"),
                    container = tags[index].closest(".js-pagination-wrap"),
                    parser = new DOMParser();

                container.setAttribute("style", "cursor:default;pointer-events:none;opacity:0.5;")

                fetch(
                    path,
                    {
                        method: "GET",
                        redirect: "follow"
                    }
                ).then(response => {
                    return response.text()
                }).then(response => {
                    response = parser.parseFromString(response, "text/html")

                    container.innerHTML = response.querySelector(".js-pagination-wrap").innerHTML

                    container.removeAttribute("style")

                    window.history.pushState({}, '', path);

                    window.initApp()

                    window.initBlogApp()
                })
            })
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    let sticky = null

    if (window.innerWidth > 997) {
        const stickySidebar = document.getElementById("sticky"), headerHeight = document.querySelector("header").offsetHeight

        stickySidebar.setAttribute("data-margin-top", headerHeight.toString())

        sticky = new Sticky("#sticky")
    }

    if (typeof Ya !== 'undefined' && Ya?.Context && window?.yaContextCb) {
        window.yaContextCb.push(() => {
            Ya.Context.AdvManager.render({
                "blockId": "R-A-14051740-16",
                "renderTo": "yandex_rtb_R-A-14051740-16",
                "onRender": function (data) {
                    if (sticky != null) {
                        sticky.update();
                    }
                }
            })
        })
    }

    window.initBlogApp()
})